var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:{markOrientest : _vm.markOrientest}},[(!_vm.addeoSmall)?_c('bloc-connexion',{attrs:{"header":true}}):_vm._e(),(_vm.paramBandeauComm)?_c('bloc-bandeau'):_vm._e(),_c('bloc-header'),_c('bloc-usages'),_c('bloc-reseau'),_c('bloc-avantages'),_c('bloc-inscription'),_c('bloc-carousel'),_c('bloc-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }